var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.173,
    height: 15.626,
    viewBox: "0 0 24.173 15.626",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view_1_",
    "data-name": "view (1)",
    transform: "translate(0 -91.866)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_608",
    "data-name": "Ellipse 608",
    cx: 3.721,
    cy: 3.721,
    r: 3.721,
    transform: "translate(8.365 95.96)",
    fill: "#0c831f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16272",
    "data-name": "Path 16272",
    d: "M23.8,98.65c-2.861-3.457-7.191-6.784-11.715-6.784S3.23,95.2.371,98.65a1.618,1.618,0,0,0,0,2.062,24.226,24.226,0,0,0,4.238,4.01c5.068,3.689,9.876,3.7,14.955,0a24.226,24.226,0,0,0,4.238-4.01A1.618,1.618,0,0,0,23.8,98.65ZM12.087,94.471a5.21,5.21,0,1,1-5.21,5.21A5.216,5.216,0,0,1,12.087,94.471Z",
    transform: "translate(0 0)",
    fill: "#0c831f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeGreen);
export default __webpack_public_path__ + "static/media/eye-green.a603dd4ac802f352066ec9ac82c9f06b.svg";
export { ForwardRef as ReactComponent };